import { useEffect } from 'react';
export default function useContentAdminPortal(name, props) {
    useEffect(function dispatchContentAdminPortalEvent() {
        window.dispatchEvent(new CustomEvent('contentadminportal', {
            detail: {
                name,
                containerId: name,
                props
            }
        }));
    }, [name, props]);
}
